import { useCallback } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { prefixRoutes } from "common/navigationRoutes"


// we need to check if to is object or string , both can be accepted for react-router

const getTargetParams = (to) => {
  if (typeof to === "string") {
    return new URLSearchParams(to.includes("?") ? to.split("?")[1] || "" : "")
  }
  if (to && typeof to === "object") {
    return new URLSearchParams(to.search || "")
  }
  return new URLSearchParams()
}

const mergeCurrentParams = (to, currentSearch) => {
  const currentParams = new URLSearchParams(currentSearch || "")
  if (currentParams.toString() === "") return to

  const targetParams = getTargetParams(to)

  // Destination params take precedence over current ones.
  currentParams.forEach((value, key) => {
    if (!targetParams.has(key)) {
      targetParams.set(key, value)
    }
  })

  const qs = targetParams.toString()

  if (typeof to === "string") {
    return `${to.split("?")[0]}${qs ? `?${qs}` : ""}`
  }

  if (to && typeof to === "object") {
    return {
      ...to,
      search: qs,
    }
  }

  return to
}

export const useAppNavigate = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const appNavigate = useCallback(
    (to, options) => {
      if (typeof to === "string" && to.startsWith("/")) {
        const currentPrefix = Object.values(prefixRoutes).find((p) =>
          location.pathname.startsWith(p)
        )
        if (currentPrefix && !to.startsWith(currentPrefix)) {
          navigate(
            mergeCurrentParams(`${currentPrefix}${to}`, location.search),
            options
          )
          return
        }
      }
      navigate(mergeCurrentParams(to, location.search), options)
    },
    [navigate, location.pathname, location.search]
  )

  return appNavigate
}

export default useAppNavigate
